import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ReactDOM from "react-dom/client";
import NavbarSet from "./Materi/Navbar";
import Home from "./Materi/Home";
import Vacancy from "./Materi/Vacancy";
import FooterWithLogo from "./Materi/Footer";
import Contact from "./Materi/Contact";

const App = () => {
  return (
    <>
    <BrowserRouter>
      <NavbarSet />
    <Routes>
      {/* <Route path="/" element={<NavbarSet />} /> */}
      <Route index element={<Home />} />
      <Route path="vacancy" element={<Vacancy />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>
    </BrowserRouter>
    <FooterWithLogo />
    </>
  )
}

export default App;